// ** React Imports
import { useState, createContext } from 'react'

// ** Intl Provider Import
import { IntlProvider } from 'react-intl'

// ** User Language Data
import userMessagesEn from '@i18n/locales/en.json'
import userMessagesDe from '@i18n/locales/de.json'
import userMessagesFr from '@i18n/locales/fr.json'
import userMessagesEs from '@i18n/locales/es.json'

// import { createIntl } from 'react-intl'

// ** Menu msg obj
const menuMessages = {
  en: { ...userMessagesEn },
  de: { ...userMessagesDe },
  fr: { ...userMessagesFr },
  es: { ...userMessagesEs }
}


// const intl = createIntl({})

// ** Create Context
const Context = createContext()

const IntlProviderWrapper = ({ children }) => {
  // ** States
  const [locale, setLocale] = useState('en')
  const [messages, setMessages] = useState(menuMessages['en'])

  // ** Switches Language
  const switchLanguage = lang => {
    setLocale(lang)
    setMessages(menuMessages[lang])
  }

  return (
    <Context.Provider value={{ locale, switchLanguage }}>
      <IntlProvider key={locale} locale={locale} messages={messages} defaultLocale='en'>
        {children}
      </IntlProvider>
    </Context.Provider>
  )
}

export { IntlProviderWrapper, Context as IntlContext }
